/**
 * Serialização de CSV compartilhada.
 *
 * `;` é o delimitador padrão: é o separador de lista do Excel pt-BR, e este
 * app se apresenta em pt-BR. Com `,`, o Excel pt-BR joga a linha inteira numa
 * célula só — o arquivo "abre", e é inútil.
 *
 * Este módulo nasceu de uma duplicação: `reference-data-csv.ts` (template de
 * ingestão) e `cost-csv.ts` (export da tela de custo) escreviam o mesmo
 * `escapeCell` de cinco linhas. Duas cópias da mesma regra de escape é como
 * uma delas passa a aceitar aspas que a outra rejeita.
 */

/** Delimitador padrão — ver a nota sobre Excel pt-BR acima. */
export const CSV_DELIMITER = ";";

/** Aspeia a célula quando ela contém o delimitador, aspas ou quebra de linha,
 *  dobrando as aspas internas (RFC 4180). */
export function escapeCsvCell(value: string, delimiter: string = CSV_DELIMITER): string {
  const needsQuotes = value.includes(delimiter) || value.includes('"') || value.includes("\n");
  return needsQuotes ? `"${value.replace(/"/g, '""')}"` : value;
}

/** Serializa uma linha. Números entram crus — formatar aqui destruiria a
 *  precisão de quem vai somar o arquivo numa planilha. */
export function csvRow(
  cells: (string | number)[],
  delimiter: string = CSV_DELIMITER,
): string {
  return cells.map((cell) => escapeCsvCell(String(cell), delimiter)).join(delimiter);
}

/** BOM UTF-8 — sem ele o Excel abre acento como caractere quebrado. */
export const CSV_BOM = "﻿";
